import $ from 'jquery'
import Widget from './base.js'
import { isTouchDevice } from 'tpm-utils'
import { Component } from 'preact'

export class MeadowsPhone extends Widget {
  componentWillMount() {
    /* max number of exchanges to show. Update this as publishing progresses */
    this.max = 10
    this.openMenu = this.openMenu.bind(this)
    this.closeTooltip = this.closeTooltip.bind(this)
    if (this.props.default) {
      this.setState({
        openExchange: parseInt(this.props.default),
        closeTooltip: true,
      })
    }
  }

  openExchange(i) {
    if (typeof i === undefined) this.openMenu()
    else this.setState({ openExchange: i, closeTooltip: true })
  }

  openMenu() {
    this.setState({ openExchange: undefined })
  }

  closeTooltip() {
    this.setState({ closeTooltip: true })
  }

  renderTooltip() {
    if (this.state.closeTooltip) return
    return (
      <div className="MeadowsPhone__Tooltip" onClick={this.closeTooltip}>
        <div>
          Below are selected exchanges from the Meadows text log. They are only
          a portion on the total messages TPM gained access to. Click on the
          participant(s)’s name to read the exchange.
        </div>
        <div class="MeadowsPhone__TooltipClose">GOT IT!</div>
      </div>
    )
  }

  /* render an exchange by index */
  renderExchange(i) {
    const thisExchange = tpm_exchanges[i].messages.map((message) => {
      const sender = message[0]
      const recipient = message[1]
      const content = message[3]

      const datetime = message[2].split(' ')
      const date = datetime[0]
      let time = datetime[1].split(':')
      const intHr = parseInt(time[0])
      if (intHr > 12) {
        time = `${intHr - 12}:${time[1]} p.m.`
      } else {
        time = `${intHr}:${time[1]} a.m.`
      }

      const fromMeadows = sender === 'Mark Meadows'

      return (
        <div class={`MeadowsPhone__Text`}>
          <div class="MeadowsPhone__TextTime">
            <b>{date}</b> at {time}
          </div>
          <div
            class={`MeadowsPhone__TextSender ${
              fromMeadows ? '--outgoing' : '--incoming'
            }`}
          >
            {sender}
          </div>
          <div
            class={`MeadowsPhone__TextContent ${
              fromMeadows ? '--outgoing' : '--incoming'
            }`}
          >
            <div
              class={`MeadowsPhone__TextBubble ${
                fromMeadows ? '--outgoing' : '--incoming'
              }`}
            >
              {content}
            </div>
          </div>
        </div>
      )
    })
    return <div class="MeadowsPhone__Bottom">{thisExchange}</div>
  }

  renderMenu() {
    const menuItems = tpm_exchanges.map((exchange, i) => {
      if (i > this.max - 1 || exchange === null)
        return (
          <div className="MeadowsPhone__Exchange --soon">
            <div className="MeadowsPhone__ExchangeInitialsContainer">
              <div className="MeadowsPhone__ExchangeInitials"></div>
            </div>
            <div class="MeadowsPhone__ExchangeRight">
              <div className="MeadowsPhone__ExchangeTop">
                <div className="MeadowsPhone__ExchangeTitle">More to come</div>
              </div>
              <div className="MeadowsPhone__ExchangeBottom">
                <div className="MeadowsPhone__ExchangeDescription">
                  ████████████████
                </div>
              </div>
            </div>
          </div>
        )
      let image = exchange.image ? (
        <img
          class="MeadowsPhone__ExchangeImage"
          src={exchange.image}
          aria-hidden="true"
        />
      ) : null
      if (!image) {
        if (exchange.image_initials.length > 4) {
          image = <div className={`MeadowsPhone__ExchangeInitials`}>5+</div>
        } else {
          image = exchange.image_initials.map((initial) => {
            const cssClass = exchange.image_initials.length > 1 ? '--small' : ''
            return (
              <div className={`MeadowsPhone__ExchangeInitials ${cssClass}`}>
                {initial}
              </div>
            )
          })
        }
      }
      return (
        <div
          class="MeadowsPhone__Exchange"
          onClick={() => {
            this.openExchange(i)
          }}
        >
          <div class="MeadowsPhone__ExchangeInitialsContainer">{image}</div>
          <div class="MeadowsPhone__ExchangeRight">
            <div className="MeadowsPhone__ExchangeTop">
              <div className="MeadowsPhone__ExchangeTitle">
                {exchange.title}
              </div>
              <div className="MeadowsPhone__ExchangeDate">{exchange.date}</div>
            </div>
            <div className="MeadowsPhone__ExchangeBottom">
              <div className="MeadowsPhone__ExchangeDescription">
                {exchange.description.substring(0, 60)}...
              </div>
              <div class="MeadowsPhone__AngleRight">
                <i class="fal fa-angle-right"></i>
              </div>
            </div>
          </div>
        </div>
      )
    })
    return <div class="MeadowsPhone__Bottom --no-scrollbar">{menuItems}</div>
  }

  get isOpen() {
    /* exchanges are 0 indexed, so we want to return true for openExchange = 0
    this accomplishes that while letting the component state store the actual
    exchange index */
    return this.state.openExchange !== undefined
  }

  renderTop() {
    if (this.isOpen) {
      const exchange = tpm_exchanges[this.state.openExchange]
      return (
        <div class="MeadowsPhone__Top --center">
          <div className="MeadowsPhone__TopExchange">
            {this.props.default ? null : (
              <div class="MeadowsPhone__TopAngleLeft" onClick={this.openMenu}>
                <i class="fal fa-angle-left"></i>
              </div>
            )}
            <div class="MeadowsPhone__TopExchangeInfo">
              <div className="MeadowsPhone__TopExchangeTitle">
                {exchange.title}
              </div>
              <div className="MeadowsPhone__TopExchangeDescription">
                {exchange.description}
              </div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div class="MeadowsPhone__Top">
        <div className="MeadowsPhone__TopTitle">Messages</div>
        <div className="MeadowsPhone__TopDescription"></div>
      </div>
    )
  }

  renderBottom() {
    if (this.isOpen) return this.renderExchange(this.state.openExchange)
    else return this.renderMenu()
  }

  renderContent() {
    return [
      this.renderTooltip(),
      <div class="MeadowsPhone__Border">
        {this.renderTop()}
        {this.renderBottom()}
      </div>,
    ]
  }
}
const tpm_exchanges = [
  {
    image: null,
    image_initials: ['SP'],
    title: 'Rep. Scott Perry',
    description:
      'A selection of key texts between Rep. Scott Perry (R-PA) and Mark Meadows.',
    date: 'Nov 8, 2020',
    messages: [
      [
        'Scott Perry',
        'Mark Meadows',
        '11/8/20 14:32',
        'Mark, please do not delay in speaking with him or Sydney Powell.',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '11/9/20 22:25',
        'Cleta asked if she should set up a C4 to deal with raising money and paying for the cyber portion. She offered to do it if necessary.',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '11/10/20 10:11',
        "Mark, so you're read in on what I've done I just sent this text to Josh Steinman. It is his contact in Michigan who I got from Ronna Mcdaniel. Her name is: Kim Jornes. Josh, this is Kim from Michigan. She will be your initial contact for your cyber team there. She is loading signal and will await your correspondence regarding team contact and instructions. Acknowledge receipt please.",
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '11/10/20 20:49',
        'Mark, these are instructions are from the cyber forensic team. Please ensure widest dissemination and action. Plz tell every state senior that they need to: 1. Preserve the specific voting machines (scanners) used at the polling places where the glitch occurred. (Put them under lock and key - nobody touches them) 2. Preserve the machines at the precinct or tally location that were used to total the votes and upload them to the Internet or state counting facility. (Put them under lock and key - nobody touches them ) 3. Preserve all email communications with the officials responsible for the software updates, authorization software updates, and deploying software updates to the voting machines. 4. Preserve all non-email communications by the officials related to the same (text messages, imessages, whatsapp, etc) - and fact of phone calls (date/time stamps) 5. Preserve all communications (as listed in 3 and 4) by the voting machine technicians or corporate officials responsible for the creation and deployment of software updates. 6. Preserve all software logs, source code, continuous deployment/continuous integration logs, associated with the software updates process that resulted in the glitch. 7. Preserve the technicians, laptop, ipad, phone, or any other device used in the official execution of their duties to update voting machines',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '11/10/20 20:57',
        'https://www.theepochtimes.com/pennsylvania-100000-ballots-with-implausible-return-dates_3572942.html?fbclid=IwAR1fberciRlTvCVdr_tCVURMitIGgOWfSZmXeeW-QsoXOcekY4zmZyT7oEs',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '11/10/20 21:02',
        'I still need a point of contact in Wisconsin and Arizona.',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '11/10/20 21:17',
        'Mark, I need the contact for a guy named Alex who is supposed to be handling the cyber effort.',
      ],
      ['Mark Meadows', 'Scott Perry', '11/10/20 21:40', 'Cip Roy'],
      [
        'Scott Perry',
        'Mark Meadows',
        '11/10/20 21:43',
        'Roger, thank you. I will contact him now.',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '11/11/20 7:09',
        "I spoke with Alex and things are more clear now. I'm going to keep working it but if I sense my involvement is impending, I will bail out.",
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '11/12/20 13:08',
        'Can you tell me who is in charge of the Wisconsin recount?',
      ],
      [
        'Mark Meadows',
        'Scott Perry',
        '11/12/20 15:17',
        'Let me know if she is willing to sign an affidavit',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '11/12/20 15:29',
        "Believe me, I'm going to do everything I can including putting you on the phone with her. Also, apparently, our dept of state shut down all its systems on Oct 2/3 and lost all its data requiring them to replace all their hard drives. Don't know yet if it matters but the state legislative auditors are holding that for their subpoenas next week.",
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '11/19/20 22:11',
        "Thanks for doing that. Talking with Rudy's folks in Philly, they want the PA legislative leaders invited ASAP for Sunday or Monday. They are in all day tomorrow passing the budget so that's out. Let me know if you want to discuss it.",
      ],
      [
        'Mark Meadows',
        'Scott Perry',
        '11/20/20 6:29',
        'As long as you are coordinating. That is fine',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '11/20/20 7:44',
        'The call will have to come from The White House.',
      ],
      [
        'Mark Meadows',
        'Scott Perry',
        '11/21/20 9:30',
        'Can you send me the number for the speaker and the leader of PA Legislature. POTUS wants to chat with them',
      ],
      ['Scott Perry', 'Mark Meadows', '11/21/20 14:16', 'Yes sir'],
      [
        'Scott Perry',
        'Mark Meadows',
        '11/21/20 22:25',
        'What will it take for Bill Mcswain to open an investigation?',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '12/24/20 22:16',
        'Mark, let me know if we can talk some strategy. Just a few minutes.',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '12/26/20 19:24',
        'Mark, just checking in as time continues to count down. 11 days to 1/6 and 25 days to inauguration. We gotta get going!',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '12/26/20 19:55',
        "Mark, you should call Jeff. I just got off the phone with him and he explained to me why the principal deputy won't work especially with the FBI. They will view it as as not having the authority to enforce what needs to be done.",
      ],
      [
        'Mark Meadows',
        'Scott Perry',
        '12/26/20 20:04',
        'I got it. I think I understand. Let me work on the deputy position',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '12/26/20 20:05',
        'Roger. Just sent you something on Signal',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '12/27/20 19:07',
        'Can you call me when you get a chance? I just want to talk to you for a few moments before I return the presidents call as requested.',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '12/28/20 11:23',
        'Did you call Jeff Clark?',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '12/29/20 10:32',
        'Mark, I sent you a note on signal',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '12/30/20 12:50',
        'Mark, need to re-visit US 18-951. It was not explained well yesterday. I think can add important context.',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '12/30/20 13:25',
        'Check your signal please.',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '12/31/20 23:44',
        "Why can't we just work with the Italian government?",
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '12/31/20 23:44',
        'https://youtu.be/YwtbK5XXAMk',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '1/2/21 11:37',
        'This is what I sent to Jim: I suspect we will be operating under the two-hour rule for limiting debate plus the rule that each member can speak only once for five minutes or less (3 USC 17).',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '1/2/21 11:37',
        'Can we conclude this does not preclude the ability of the President of the Senate�Vice President Pence�to admit testimony before commencing the debate?',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '1/2/21 11:37',
        '�admit testimony� means Senate or House convenes as committee of the whole and hears sworn statements from persons who are willing to offer evidence and views but who are NOT members of Congress.',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '1/2/21 11:38',
        '�Debate� takes place in House solely between members of the House. And �debate� takes place in Senate solely between members of the Senate.',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '1/2/21 11:39',
        'Also,has POTUS been able to have a conversation with Conti? Can he move the ball today?',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '1/2/21 22:51',
        'Please call me the instant you get off the phone with Jeff.',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '1/5/21 16:28',
        'Please check your signal',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '1/7/21 15:35',
        'Mark, please call when you can',
      ],
    ],
  },
  {
    image: null,
    image_initials: ['SP', 'JJ'],
    title: 'Rep. Scott Perry, Rep. Jim Jordan',
    description:
      'A selection of key texts between from Rep. Scott Perry (R-PA) to Mark Meadows and Rep. Jim Jordan (R-OH).',
    date: 'Nov 12, 2020',
    messages: [
      [
        'Scott Perry',
        'Mark Meadows',
        '11/12/20 8:17',
        "FYI so you're aware, this is from one of the state representatives in PA. I think it's a reasonable assessment of what's possible there.: My thoughts on PA �audit� and what we should be pursuing with the limited time and money we have. 1. We pushed leadership as hard as we could two days ago and the bottom line in my opinion is they lack the heart and/or think they lack the time and money to do a full audit. 2. We need to see if any addresses had high numbers of mail-in ballots DELIVERED to them. NOT requested from them (that's tied to voter address) but delivered to them. That's a simple database query and sort. Can do it in 10 minutes if we have the data. If there'a coordinated AND provable fraud that would be the big flag. Fraud like driving around harvesting ballots would be near impossible to prove and not a rabbit hole worth pursuing. But if they we're getting mail in ballots for inactive/disinterested type voters to be completed for them, and were too lazy to go around and collect them, it would be easy enough to simply have them sent to volunteers/cheaters' homes or similar. Not saying that happened but it may have ... record turnout skewed so heavily to mail in a state where voters are unaccustomed to mail-in, all during a pandemic that killed the Ds ground game for a candidate no one was excited about seems hard to pull off ... and it's easy to check at least one way it may have happened. 3. People think Dominion software was hacked. Well that's why we went to paper ballots ... to have a paper audit trail. Find 50-100 precincts that seem to have gone heavier for Biden than expected and hand count them or even just rescan them. Get the totals and see if that's consistent with what Dominion reported for that precinct and/or extrapolate across a given county, etc. and see if consistent with the numbers reported. Again, could figure out and execute a plan that's easy, cost effective, and would at least rule out mass coordinated cheating. 4. Still think pursuing voters disenfranchised by mandated Covid quarantine is worthwhile but I've been surprised at how little response we've gotten on that front. A few people but not a lot. 5. Our office has found what we think are somewhere between 3-15 dead people who voted in our district alone. Pushing my people to fully vet that by end of day today. That information has been turned over to the attorneys. 6. I wouldn't mess with much else (at least what's within my purview) beyond that other than maybe interviewing or reviewing claims of some cross section of people saying they were denied access to polls. And of course whatever you guys feel the SOS did wrong in regards to following court orders, inconsistent guidance to counties etc. But I'm not sure that requires much of an audit per se.",
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '11/12/20 9:27',
        'From an Intel friend: DNI needs to task NSA to immediately seize and begin looking for international comms related to Dominion - was china malware involved?',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '11/12/20 9:28',
        'DNI needs to be tasked to audit their overseas accounts at CIA - and their National Endowment for Democracy.',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '11/12/20 9:28',
        'This whole situation was seen coming a hundred miles away and they did nothing.',
      ],
      [
        'Scott Perry',
        'Mark Meadows',
        '11/12/20 9:28',
        'And Gina is still running around on the Hill covering for the Brits who helped quarterback this entire operation.',
      ],
    ],
  },
  {
    image: null,
    image_initials: ['AB'],
    title: 'Rep Andy Biggs',
    description:
      'A selection of key texts between Rep. Andy Biggs (R-AZ) and Mark Meadows.',
    date: 'Nov 3, 2020',
    messages: [
      [
        'Andy Biggs',
        'Mark Meadows',
        '11/3/20 10:08',
        'this is the first hour voting trend. Republicans voting at three times Dems.',
      ],
      ['Mark Meadows', 'Andy Biggs', '11/3/20 10:10', 'Outstanding'],
      [
        'Andy Biggs',
        'Mark Meadows',
        '11/3/20 18:35',
        "This is the latest. We've expanded our leader Democrats to well over 30,000 votes. Also I called my consultants again and they tell me that the independence are probably breaking even better than two or 3% for Trump because they're so active today. And that an independent voting for Biden would've already done it through mail in ballot because they don�t trust the Covid. Ha ha",
      ],
      [
        'Andy Biggs',
        'Mark Meadows',
        '11/3/20 23:31',
        "So, Fox called bu this is the situation that has been reported to me: outstanding ballots are600-700K statewide. Those are dropped off and day of votes. Fox doesn't know what they are doing. Too many votes. Probably one more report tonight.",
      ],
      [
        'Andy Biggs',
        'Mark Meadows',
        '11/4/20 2:59',
        'Mark they will start counting in Maricopa county tomorrow morning at 7:30 AM and they will go and release only one report at the end of the day. Whatever happens no one can concede because the president will win the state. After you and I talked another 10,000 votes came the presidents way so please make sure no one in the campaign or press office says anything about conceding in Arizona because I am very confident that as this thing goes President Trump is going to win',
      ],
      [
        'Andy Biggs',
        'Mark Meadows',
        '11/4/20 21:14',
        'Still about 340k Maricopa County ballots. And 180k additional statewide',
      ],
      ['Mark Meadows', 'Andy Biggs', '11/4/20 21:15', 'Ok'],
      [
        'Mark Meadows',
        'Andy Biggs',
        '11/4/20 21:19',
        'Not enough to help us get there',
      ],
      [
        'Andy Biggs',
        'Mark Meadows',
        '11/4/20 21:20',
        "Well he won by 59% of the 75,000 some odd votes today. He needs to win by 56% of everything to win so I think there's plenty of boats there provided the ratio stay strong",
      ],
      ['Mark Meadows', 'Andy Biggs', '11/4/20 21:20', 'Ok'],
      ['Mark Meadows', 'Andy Biggs', '11/6/20 12:52', 'Any hope for Az'],
      [
        'Andy Biggs',
        'Mark Meadows',
        '11/6/20 12:54',
        "I've been trying to get hold of our legal and party teams in Arizona. By my calculations president needs to win about 59 1/2% of the outstanding balance to win. There are 225,000 statewide balance (140,000 Maricopa county ballots left ). So still doable",
      ],
      [
        'Andy Biggs',
        'Mark Meadows',
        '11/6/20 20:48',
        "I'm sure you have heard of this proposal. It is to encourage the state legislatures to appoint a look doors in the various states where there's been shenanigans. If I understand right most of those states have Republican Legislature�s. It seems to be comport with glorified Bush as well as the Constitution. And, well highly controversial, it can't be much more controversial than the lunacy that were sitting out there now. And It would be pretty difficult because he would take governors and legislators with collective will and backbone to do that. Is anybody on the team researching and considering lobbying for that?",
      ],
      ['Mark Meadows', 'Andy Biggs', '11/6/20 20:56', 'I love it.'],
      [
        'Andy Biggs',
        'Mark Meadows',
        '11/7/20 14:51',
        "Please don't let the President concede. We must exhaust all options",
      ],
      [
        'Andy Biggs',
        'Mark Meadows',
        '11/8/20 16:17',
        "Hey Mark the president asked me to call Governor Ducey I did and Ducey won't talk to me he will only let me talk to his Chief of Staff. But based on hints that were given to me looks like the governor wants to punch this to county board of supervisors. I did talk to the legal team and as a result I've placed some calls to the board of supervisors without connecting so far. I'll keep trying",
      ],
      [
        'Mark Meadows',
        'Andy Biggs',
        '11/10/20 20:24',
        'How many total ballots left',
      ],
      [
        'Andy Biggs',
        'Mark Meadows',
        '11/10/20 20:25',
        "We think there's still around 55-60k",
      ],
      ['Mark Meadows', 'Andy Biggs', '11/10/20 20:25', 'Ok'],
      [
        'Andy Biggs',
        'Mark Meadows',
        '11/10/20 21:22',
        'Wait all day for 5k ballots... This is inexcusable.',
      ],
      ['Andy Biggs', 'Mark Meadows', '11/11/20 22:19', 'Not enough'],
      [
        'Andy Biggs',
        'Mark Meadows',
        '11/12/20 11:49',
        'This guy is the one that wants to talk about dominion software Thanks',
      ],
      [
        'Mark Meadows',
        'Andy Biggs',
        '11/12/20 15:44',
        'Can you get me the attorney general of Arizona phone number',
      ],
      ['Andy Biggs', 'Mark Meadows', '11/12/20 15:50', 'Yes'],
      ['Mark Meadows', 'Andy Biggs', '11/12/20 15:57', 'Thanks'],
      [
        'Andy Biggs',
        'Mark Meadows',
        '11/13/20 13:50',
        "So one of the remedies that may still be left is to enjoin the certification of the election based on the Fed only ballots. If we can't get the investigation done in time for that, we should make sure we have it done in time and can demonstrate that a significant number of illegal aliens votes in the election so that the legislature, when called into certify the electors, can reject them based on fraud. What do you think?",
      ],
      ['Mark Meadows', 'Andy Biggs', '11/13/20 14:13', 'I like it'],
      [
        'Andy Biggs',
        'Mark Meadows',
        '11/17/20 18:56',
        "I'm speaking to the Arizona GOP executive board tonight. Anything you'd like me to tell them in particular",
      ],
      [
        'Andy Biggs',
        'Mark Meadows',
        '11/18/20 19:40',
        "Mark the total number of native Americans in Arizona is an excess of 425,000. I'm waiting for the number of voters to come back",
      ],
      [
        'Mark Meadows',
        'Andy Biggs',
        '11/22/20 18:55',
        'What is gov Ducey cell phone',
      ],
      [
        'Andy Biggs',
        'Mark Meadows',
        '11/22/20 18:57',
        "Also I am talking with Kelly Ward about the so-called adjudicated ballots. That's the 130,000 ballots she's talking about. I'm trying to get to the bottom of the process and see if there's a way we can audit those",
      ],
      ['Mark Meadows', 'Andy Biggs', '11/22/20 18:59', 'Ok'],
      [
        'Andy Biggs',
        'Mark Meadows',
        '11/22/20 19:00',
        "Don't hold out false hope on that but there is a glimmer potentially there but we shouldn't get overhyped on it",
      ],
      ['Mark Meadows', 'Andy Biggs', '11/22/20 19:00', 'Ok'],
      [
        'Andy Biggs',
        'Mark Meadows',
        '11/29/20 19:14',
        "Hey Mark, the circus is coming to town tomorrow and I wanted your input. Giuliani and company will be in downtown Phoenix I'm planning on being there. Anything I should look out for your address when I speak to the crowd?",
      ],
    ],
  },
  {
    image: null,
    image_initials: ['RA'],
    title: 'Rep. Rick Allen',
    description:
      'A selection of key texts between Rep. Rick Allen (R-GA) and Mark Meadows.',
    date: 'Nov 25, 2020',
    messages: [
      [
        'Rick Allen',
        'Mark Meadows',
        '11/25/20 12:03',
        'Mark, this is Rick Allen. I just got of the phone with a high ranking government official and decorated JAG Officer. I know you are busy as we are in Georgia but he revealed some things to me that the President needs to know. The FBI and DOJ are slow walking these investigations into voter fraud in Georgia. I headed a delegation letter to the DOJ specifically asking for an investigation two weeks ago and we have heard nothing? My source confirmed that there is wide spread fraud in multiple states! Let me know a good time to talk, thanks!',
      ],
      [
        'Mark Meadows',
        'Rick Allen',
        '11/26/20 17:50',
        'Let me know if I need to travel to hear in person the concerns. I can go tomorrow',
      ],
      [
        'Rick Allen',
        'Mark Meadows',
        '11/26/20 18:22',
        'The source that is feeding my source some voter fraud information contacted me directly. They sent it to me and it is mostly Data breeches of drivers licenses in Georgia and Texas and probably all the swing states that can be used to commit voter fraud. I am going through it now. I am sure their office is overwhelmed with this type of information. It is wild stuff! Waiting to hear back from my source to set up a time to talk tomorrow. They may be out of town for the Holiday so best to handle by phone until I know something.',
      ],
      ['Mark Meadows', 'Rick Allen', '11/26/20 18:23', 'Ok'],
      [
        'Rick Allen',
        'Mark Meadows',
        '11/26/20 20:45',
        'Mark, just heard from my source. Something is up? He asked for a couple of days before he can talk at the highest level. I know time is short but I have the highest respect for this man and I am certain he wants to be prepared to talk at the appropriate time. It could be that higher ups at DOJ have engaged as well. From what I can tell so far looks like this is high tech and foreign governments in collusion with Democratic Party to guarantee Biden would win which explains that the President was hundreds of thousands of votes ahead until they figured out what they needed. As I said this is wild stuff! I will send you some of the intel that was sent to me. There is no way in Georgia that the down ballot out performed the President. In my District the President won by 17 points and I won by 18 in an R5 District. Tell the President to hang in there, so many are praying for God�s revelation and a miracle!',
      ],
      [
        'Rick Allen',
        'Mark Meadows',
        '11/26/20 20:47',
        'https://www.securityinfowatch.com/cybersecurity/information-security/press-release/10594538/associated-press-state-of-georgia-drivers-license-files-hacked',
      ],
      [
        'Rick Allen',
        'Mark Meadows',
        '11/26/20 20:50',
        'Romanian illegal activity 3:40 � 50 million stolen us identities 7:37 � used by thiefs for online shopping, loans, election fraud, 8:24 � produce duplicate copies of driver licenses to commit election fraud 8:40 � to allow mail in voting from home 9:12 � emails, passwords and all the data from your phone or laptop..and they will use these data in the election process without you realizing. 10:18 �Planning this since 2009 10:48 �100,000 Ukrainian illegally into the USA and "mules" to blackmail 1m US citizens to vote 13:40 �defrauding 50m US citizens over $100B over past 11 years 15:30 �received a second set of data in 2018 15:50 �consequences of Trump reelection',
      ],
      [
        'Rick Allen',
        'Mark Meadows',
        '11/26/20 20:51',
        "In fact, the number of personal records that were exposed--data like Social Security numbers, medical records and credit card information tied to an individual--that hackers exposed has skyrocketed to 220 million records so far this year, compared with 35 million in 2008. That represents the largest collection of lost data on record. And the majority of 2009's data loss stems from a single source: credit card processing firm Heartland Payment Systems.",
      ],
      [
        'Rick Allen',
        'Mark Meadows',
        '11/26/20 20:54',
        'https://www.youtube.com/watch?v=wWABaYncRRc',
      ],
      [
        'Rick Allen',
        'Mark Meadows',
        '11/26/20 20:59',
        'I just got a notice from You Tube that they have closed me out, I was told that that the video I just sent you would be taken down? It disappeared? What is going on?',
      ],
      [
        'Rick Allen',
        'Mark Meadows',
        '12/20/20 9:31',
        "Mark I know you are getting a lot of requests for pardons. This man worked with my Dad and got the Flynn treatment from FBI. Please extend my thanks to the President for his consideration. On another note my source with US Attorney's Office��is presenting his case on election fraud to the Office of election integrity tomorrow, and I will let you know what happens. Thanks and Merry Christmas to you and yours, Rick.",
      ],
      [
        'Rick Allen',
        'Mark Meadows',
        '1/5/21 8:32',
        'Mark, thought the President might want to tweet this. I will send you the text chain between me and Raffensperger. Bottom line Dominion machines down in multiple polling precincts in Columbia County my Republican Strong Hold. This should give the President the Ammo he needs to go after Raffensperger. Call me if you have any questions, this has been going on since 7 am this morning, I have alerted both the Perdue and Loeffler campaigns s and they are on it.',
      ],
      [
        'Rick Allen',
        'Mark Meadows',
        '1/5/21 8:33',
        'Brad, just called you, my constituents in Columbia County are furious. Scanners are down in at minimum of 3 locations. People are waiting in line to vote but are going to have to leave and go to work. This is voter suppression in a Republican stronghold and I am holding you responsible, Dominion has to go, I have had it with this incompetence! Rick',
      ],
      [
        'Rick Allen',
        'Mark Meadows',
        '1/5/21 8:34',
        'Already working on it, Brad',
      ],
      ['Mark Meadows', 'Rick Allen', '1/5/21 8:34', 'Thanks'],
      [
        'Rick Allen',
        'Mark Meadows',
        '1/8/21 11:50',
        "Mark, please know that I have prayed for President Trump, his family, for you and the entire Administration. Our Nation is at war, it is a Spiritual War at the highest level. This is not a war that can be fought conventionally, this is God's battle and He has used President Trump in a powerful way to expose the deceit, lies and hypocrisy of the enemy. The Trump family and all of us have paid a heavy price to be used by the Father but the War is just beginning. We have had a major set back and people are taking sides, and my plea to my fellow believers who want to cut and run is judge not less you be judged, we have all fallen short of the Glory of Almighty God. What I heard during my prayers is the Trump family and the Administration need to be surrounded by those great Pastors and Evangelicals who have snd continue to love and support them. President Trump need to be ministered to, he needs the love that only Jesus Christ offers! This is his opportunity to confess that he can no longer fight this battle alone, he must give it to Christ and Gid almighty will show him the way to victory. I will continue to pray for all of you, please let me know how I can help??",
      ],
      ['Mark Meadows', 'Rick Allen', '1/8/21 11:51', 'God bless you'],
    ],
  },
  null,
]
